// Navigation model shared by the shell chrome (top bar, bottom nav, sidebar).

import { APP_REGISTRY } from '../registry/appRegistry';

// The mobile bottom-nav tabs (matches the screenshot).
export const BOTTOM_TABS = [
  { id: 'home', label: 'Home', icon: 'Home', path: '/' },
  { id: 'categories', label: 'Categories', icon: 'LayoutGrid', path: '/categories' },
  { id: 'my-apps', label: 'My Apps', icon: 'Layers', path: '/my-apps' },
  { id: 'updates', label: 'Updates', icon: 'Bell', path: '/updates' },
  { id: 'more', label: 'More', icon: 'MoreHorizontal', path: '/more' },
];

// The shell's own routes — everything else is treated as "an app is open".
const SHELL_EXACT = ['/', '/store', '/categories', '/my-apps', '/updates', '/more', '/workspaces', '/admin/app-control'];
const SHELL_PREFIX = ['/store/', '/apps/'];

export const isShellRoute = (pathname) =>
  SHELL_EXACT.includes(pathname) || SHELL_PREFIX.some((p) => pathname.startsWith(p));

// Apps that render their OWN top bar and must not sit under Hive's.
//
// EMPTY ON PURPOSE. Fair Tracker was briefly here, and the result was an app
// you could not get out of: Hive's back arrow was gone, and Fair Tracker's own
// bar is hidden on its first-run screen. Consistency with every other app —
// the Hive top bar is always present, and its back arrow always works — beats
// the ~56px of vertical space that suppressing it would save.
//
// An app added here must provide its own always-visible way back to Hive.
const FULL_BLEED_PREFIX = [];

export const isFullBleedRoute = (pathname) =>
  FULL_BLEED_PREFIX.some((p) => pathname === p || pathname.startsWith(p + '/'));

// Which bottom tab / sidebar entry is active for the current path.
export const activeTab = (pathname) => {
  if (pathname === '/') return 'home';
  if (pathname === '/my-apps') return 'my-apps';
  if (pathname === '/updates') return 'updates';
  if (pathname === '/more' || pathname === '/workspaces' || pathname.startsWith('/settings') || pathname.startsWith('/admin')) return 'more';
  if (pathname === '/categories' || pathname === '/store' || pathname.startsWith('/store/') || pathname.startsWith('/apps/')) return 'categories';
  return null; // an app is open
};

// When an app is open, resolve a display title for the contextual top bar.
export const openAppTitle = (pathname) => {
  const app = APP_REGISTRY.find((a) => a.path && (pathname === a.path || pathname.startsWith(a.path + '/')));
  if (app) return app.name;
  if (pathname.startsWith('/settings/manage-company')) return 'Company Apps';
  if (pathname.startsWith('/settings/manage-employee')) return 'User Apps';
  if (pathname.startsWith('/settings/manage-folder')) return 'Manage Folders';
  if (pathname.startsWith('/settings')) return 'Settings';
  if (pathname.startsWith('/file-manager')) return 'File Manager';
  return 'BeeNexa';
};
